import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ExportHeaderConstants } from 'src/app/export.header.constants';
import { AlarmsService } from 'src/app/service/alarms.service';
import { ExcelService } from 'src/app/service/excel.service';

@Component({
    selector: 'app-stats',
    templateUrl: './stats.component.html',
    styleUrls: ['./stats.component.scss'],
    standalone: false // NOSONAR
})
export class StatsComponent implements OnInit {

  @Input() alarmStats: any;
  @Input() selectedDomiciles: any;
  @Input() selectedPeriod: any;
  @Input() selectedGroup: any;
  rowData: any;
  alarmRoutes: any;
  showRoutes: boolean = false;
  showRoutesButtonClicked: boolean = false;
  routesMessage: string = '';
  exportSummaryButtonClicked: boolean = false;
  exportRoutesButtonClicked: boolean = false;
  exportSummaryMessage: string = '';
  exportRoutesMessage: string = '';
  selectedAlarm: string = '';
  selectedAlarmId: string = '';
  pipe: any;
  exportConstants: ExportHeaderConstants = new ExportHeaderConstants();

  constructor(private readonly alarmsService: AlarmsService, private readonly excelService: ExcelService, private readonly ngxUiLoaderService: NgxUiLoaderService) {
    this.pipe = new DatePipe('en-US');
  }

  ngOnInit(): void {    // NOSONAR
  }

  exportRoutes() {
    console.info('AlarmId from exportRoutes(): ' + this.selectedAlarmId);
    this.exportRoutesButtonClicked = true;
    this.exportRoutesMessage = 'Exporting the selected alarm routes into xlsx file, please wait!';
    this.rowData = this.alarmRoutes;
    if (this.rowData.length > 0) {
      this.excelService.exportAsExcelFile(
        this.exportConstants.getExportData(this.rowData, this.selectedAlarmId, this.selectedAlarm),
        'Alarm_Routes',
        this.exportConstants.getExportHeaders(this.selectedAlarmId)
      );
    } else {
      console.info('Route data length is ZERO');
    }
    this.exportRoutesMessage = '';
  }
  
  formatPeriod(str:string) {
    const arr = str.split('-')
    return arr[1]+'-'+arr[0];
  }
  
  showAlarmRoutes(stat) {
    this.exportSummaryButtonClicked = false;   
    this.showRoutesButtonClicked = true;
    this.routesMessage = 'Fetching the selected alarm routes, please wait!';
    this.showRoutes = false;
    this.alarmRoutes = '';
    const dataArr = {      
      "alarmId": stat.alarmId,
      "alarm": stat.alarm,
      "period": this.formatPeriod(this.getSelectedPeriod(this.selectedPeriod)),
      "domiciles": this.getSelectedDomiciles(this.selectedDomiciles),
      "alarmsGroup": this.getSelectedAlarmsGroup(this.selectedGroup)
    }
    this.selectedAlarm = stat.alarm;
    this.selectedAlarmId = stat.alarmId;
    this.alarmsService.getAlarmRoutes(dataArr).subscribe(result => {
      if (result?.length > 0) {
        this.showRoutesButtonClicked = false;
        this.routesMessage = '';
        this.showRoutes = true;
        this.alarmRoutes = result;
      } else {
        this.showRoutesButtonClicked = false;
        this.routesMessage = '';
        console.info('Alarm Routes not found!');
      }
    });
  }

  exportAlarmsSummary() {
    this.showRoutesButtonClicked = false;
    this.exportSummaryButtonClicked = true;
    this.exportSummaryMessage = 'Exporting the alarms summary into xlsx file, please wait!';
    const dataArr = {      
      "period": this.formatPeriod(this.getSelectedPeriod(this.selectedPeriod)),
      "domiciles": this.getSelectedDomiciles(this.selectedDomiciles),
      "alarmsGroup": this.getSelectedAlarmsGroup(this.selectedGroup)
    }
    this.alarmsService.getAlarmsSummary(dataArr).subscribe(result => {
      if (result?.length > 0) {
        this.rowData = result;
        if (this.rowData.length > 0) {
          const exportData: any = [];
          this.rowData.forEach(element => {
            const obj = {
              period: element.period,
              alarmGroup: element.alarmGroup,
              alarmType: element.alarmType,
              alarmId: element.alarmId,
              alarm: element.alarm,
              routeListNumberItemCode: element.routeListNumberItemCode,
              basicCycleStart: element.basicCycleStart,
              basicCycleEnd: element.basicCycleEnd,
              areaCode: element.areaCode,
              domicile: element.domicile,
              routeDate: element.routeDate,
              puRoute: element.puRoute,
              route: element.route,
              run: element.run,
              routeType: element.routeType,
              supplier: element.supplier,
              plant: element.plant,
              dock: element.dock,
              palletizationCode: element.palletizationCode,
              logisticsPoint: element.logisticsPoint,
              fromLogisticsPoint: element.fromLogisticsPoint,
              toLogisticsPoint: element.toLogisticsPoint,
              orderDate: element.orderDate,
              orderSequence: element.orderSequence,
              accessSequence: element.accessSequence,
              gridSequence: element.gridSequence,
              unloadRoute: element.unloadRoute,
              reloadRoute: element.reloadRoute,
              connectionTime: element.connectionTime,
              connectionTime24h: element.connectionTime24h,
              resourceType: element.resourceType,
              driverType: element.driverType,
              logisticsPointDate: element.logisticsPointDate,
              combinationNumber: element.combinationNumber,
              shortage: element.shortage,
              overtime: element.overtime,
              orders: element.orders,
              arrivalDate: element.arrivalDate,
              departureDate: element.departureDate,
              overlapPuroute: element.overlapPuroute,
              overlapRoute: element.overlapRoute,
              overlapRun: element.overlapRun,
              overlapArrivalDate: element.overlapArrivalDate,
              overlapDepartureDate: element.overlapDepartureDate
            };
            exportData.push(obj);
          });

          const headers = ['PERIOD', 'ALARM_GROUP', 'ALARM_TYPE',
            'ALARM_ID', 'ALARM', 'ROUTE_LIST_NUMBER_ITEM_CODE', 'BASIC_CYCLE_START', 'BASIC_CYCLE_END', 'AREA_CODE', 'DOMICILE', 'ROUTE_DATE',
            'PUROUTE', 'ROUTE', 'RUN', 'ROUTE_TYPE', 'SUPPLIER', 'PLANT', 'DOCK', 'PALLETIZATION_CODE', 'LOGISTICS_POINT', 'FROM_LOGISTICS_POINT',
            'TO_LOGISTICS_POINT', 'ORDER_DATE', 'ORDER_SEQUENCE', 'ACCESS_SEQUENCE', 'GRID_SEQUENCE', 'UNLOAD_ROUTE', 'RELOAD_ROUTE', 'CONNECTION_TIME',
            'CONNECTION_TIME_24H', 'RESOURCE_TYPE', 'DRIVER_TYPE', 'LOGISTICS_POINT_DATE', 'COMBINATION_NUMBER', 'SHORTAGE', 'OVERTIME', 'ORDERS',
            'ARRIVAL', 'DEPARTURE', 'OVERLAP_PUROUTE', 'OVERLAP_ROUTE', 'OVERLAP_RUN', 'OVERLAP_ARRIVAL', 'OVERLAP_DEPARTURE'];

          this.excelService.exportAsExcelFile(exportData, 'Alarms_Summary', headers);
          this.exportSummaryMessage = 'Alarms Summary exported successfully!';
        }
      } else {
        this.exportSummaryMessage = 'Something went wrong while getting the Alarms Summary!';
        console.info('No Alarms Summary returned in exportAlarmsData.');
      }
    });    
  }

  getDate(dt: any) {
    return this.pipe.transform(dt, 'MM/dd/yyyy');
  }

  getSelectedPeriod(input: any) {
    return JSON.stringify(input, ['value']).substr(10, 8);
  }

  getSelectedDomiciles(_input: any) {
    let strDomiciles = '';
    this.selectedDomiciles.forEach(element => {
      if (strDomiciles == '') {  // NOSONAR
        strDomiciles = strDomiciles + JSON.stringify(element, ['value']).substr(10, 5);
      } else {
        strDomiciles = strDomiciles + ',' + JSON.stringify(element, ['value']).substr(10, 5);
      }
    });
    return strDomiciles;
  }

  getSelectedAlarmsGroup(input: any) {
    return JSON.stringify(input, ['value']).substr(10, 1);
  }
}